module.exports = __webpack_public_path__ + "static/media/eliteIcon.177f60ca.svg";